import { MilestoneData, MilestoneStatus } from '../types/milestones';
import httpClient from './httpClient';

export const milestonesApi = {
  getMilestones: async (): Promise<MilestoneData> => {
    try {
      const response = await httpClient.get('/v1/objectives/');
      return response.data;
    } catch (error) {
      console.error('Error fetching milestones:', error);
      throw error;
    }
  },
  getUpcomingMilestones: async (): Promise<MilestoneData> => {
    try {
      const response = await httpClient.get('/v1/objectives/upcoming-milestones');
      return response.data;
    } catch (error) {
      console.error('Error fetching milestones:', error);
      throw error;
    }
  },
  updateMilestoneStatus: async (
    milestoneId: string, 
    status: MilestoneStatus, 
    pathContext: {
      objective_id: string;
      key_activity_id: string;
      goal_id: string;
      activity_id: string;
    }
  ): Promise<void> => {
    try {
      await httpClient.patch(`/v1/objectives/milestones/${milestoneId}`, {
        path: pathContext,
        update: {
          status
        }
      });
    } catch (error) {
      console.error('Error updating milestone status:', error);
      throw error;
    }
  }
}; 